import { render, staticRenderFns } from "./Tooltip.global.vue?vue&type=template&id=007f9fde&scoped=true&lang=pug&"
import script from "./Tooltip.global.vue?vue&type=script&lang=ts&"
export * from "./Tooltip.global.vue?vue&type=script&lang=ts&"
import style0 from "./Tooltip.global.vue?vue&type=style&index=0&id=007f9fde&lang=scss&scoped=true&"
import style1 from "./Tooltip.global.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f9fde",
  null
  
)

export default component.exports